import React from 'react';
import IGiftList from '../interfaces/IGiftList';

interface IProps {
    giftList: IGiftList;
}

const ContributeIntro: React.FC<IProps> = ({ giftList }) => {
    const { welcome_message, title, event_date, code } = giftList;

    return (
        <section className="c-contributeIntro">
            <h3 className="c-contributeIntro__title">{title}</h3>
            <dl className="flex-row-wrap c-contributeIntro__summary">
                <dt className="c-contributeIntro__key">Wedding date: </dt>
                <dd className="c-contributeIntro__value">{event_date}</dd>
                <dt className="c-contributeIntro__key">Gift list: </dt>
                <dd className="c-contributeIntro__value">{code}</dd>
            </dl>
            <p className="c-contributeIntro__content">{welcome_message}</p>
        </section>
    );
};

export default ContributeIntro;
